import * as React from 'react';
import styled, { css } from 'styled-components';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  disabled?: boolean;
  onClick: () => void;
}

const LinkButtonBase = (props: IProps) => {
  return (
    <button className={props.className} disabled={props.disabled} onClick={props.onClick}>
      {props.children}
    </button>
  )
}

const LinkButton = styled(LinkButtonBase)`
  color: RoyalBlue;
  cursor: pointer;
  text-decoration: underline;
  border: none;
  background: none;
  &:hover {
    text-decoration: none;
  }
  &:disabled {
    color: #666;
    text-decoration: none;
    cursor: auto;
  }
`

export { LinkButton }
